import React from 'react';
import { Link } from 'react-router-dom';
import LogoLink from './LogoLink.jsx';

const NavigationBar = () => {
  return (
    <div style={{
      width: '100%',
      background: '#0f172a',
      borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
      position: 'sticky',
      top: 0,
      zIndex: 1000
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '16px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <LogoLink iconSize={24} />

        <Link
          to="/members"
          style={{
            padding: '8px 16px',
            background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
            color: '#ffffff',
            borderRadius: '6px',
            textDecoration: 'none',
            fontSize: '0.9rem',
            fontWeight: '500',
            transition: 'transform 0.2s ease'
          }}
          onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
          onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
        >
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default NavigationBar;
